var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGcpCloudIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 87,
    viewBox: "0 0 97 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3258 0C3.31036 0 3.29492 0 3.27948 0C1.58104 0 0.191406 1.38963 0.191406 3.08808C0.191406 3.25792 0.206847 3.41232 0.237727 3.58217L13.3466 83.1619C13.6863 85.1692 15.4311 86.6514 17.4538 86.6669H80.3425C81.8711 86.6823 83.1835 85.5706 83.4305 84.0729L96.5394 3.59761C96.5703 3.42777 96.5857 3.27336 96.5857 3.10352C96.5857 1.40508 95.1961 0.01544 93.4977 0.01544C93.4822 0.01544 93.4668 0.01544 93.4513 0.01544L3.3258 0ZM58.5252 57.5154H38.4527L33.0177 29.1206H63.3889L58.5252 57.5154Z",
    fill: "#2684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3727 29.1208H63.3911L58.5274 57.5157H38.4549L14.7539 85.6481C15.5105 86.2966 16.4678 86.6517 17.456 86.6672H80.3601C81.8887 86.6826 83.2011 85.5709 83.4482 84.0732L92.3727 29.1208Z",
    fill: "url(#paint0_linear_10379_8743)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10379_8743",
    x1: 99.0918,
    y1: 37.1078,
    x2: 45.0884,
    y2: 79.2555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcpCloudIcon);
export default __webpack_public_path__ + "static/media/gcp-cloud-icon.5712389b6b83b811aa19127224149799.svg";
export { ForwardRef as ReactComponent };